<template>
  <div id="app">
  <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
body {
  margin: 0;
  overflow: hidden;
}
 html,body,#app{
    height: 100%;
    background: #f3f8fe;
  }
.message-box {
  width: 600px;
}
.message-box-pi{
  width: 700px;
}
.message-box p,.message-box-pi p{
  text-align: justify;
}
.message-box-weiyuan{
  width: 700px;
}
.dialog-pi-container{
  width:fit-content;
  max-width: 900px;
}
.dialog-pi-container p{
  line-height: 32px;
}
div.el-tree-node{
  white-space:inherit;
}
div.el-tree-node__content{
  min-height: 26px;
  line-height: 20px;
  height: inherit;
}
</style>
